import * as React from 'react';
import { Colors } from '../../styles';
export const HealthStarIcon = ({ fill }) => {
    const green = Colors.ProgressGreen;
    const gray = Colors.BackgroundGrayD;
    const size = 24.8;
    const points = '12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26';
    if (fill === 'full') {
        return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24" },
            React.createElement("polygon", { points: points, fill: green })));
    }
    if (fill === 'half') {
        return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24" },
            React.createElement("defs", null,
                React.createElement("clipPath", { id: "halfStarClip" },
                    React.createElement("rect", { x: "0", y: "0", width: "12", height: "24" }))),
            React.createElement("polygon", { points: points, fill: gray }),
            React.createElement("polygon", { points: points, fill: green, clipPath: "url(#halfStarClip)" })));
    }
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24" },
        React.createElement("polygon", { points: points, fill: gray })));
};
